import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div className="card denied">
      <div className="big" aria-hidden="true">
        404
      </div>
      <b>Страница не найдена</b>
      Такого адреса в админке нет.
      <div style={{ marginTop: 14 }}>
        <Link className="btn" to="/">
          На дашборд
        </Link>
      </div>
    </div>
  )
}
